/**
 * Palo Alto Custom Sibling Swatch Optimization Interceptor
 * High-performance event delegation with template extraction & caching.
 */
(function() {
  'use strict';

  // High-performance cache structure to hold internal card images
  // Prevents layout thrashing by saving node lookups in a garbage-collected map
  const cardCache = new WeakMap();
  let hoverTimeout = null;

  // 1. Intercept mouse entering a sibling swatch button anywhere on the page
  document.addEventListener('mouseenter', function(event) {
    if (!event.target || typeof event.target.closest !== 'function') return;

    const swatchButton = event.target.closest('[data-sibling-swatches-component] [data-swatch-button]');
    if (!swatchButton) return;

    const card = swatchButton.closest('.product-grid-item') || swatchButton.closest('[data-product-grid-item]');
    if (!card) return;

    const deferredEl = card.querySelector('deferred-loading');
    if (!deferredEl) return;

    const labelEl = swatchButton.querySelector('.swatch__label');
    if (!labelEl) return;

    const targetVariantID = labelEl.getAttribute('data-swatch-variant');
    if (!targetVariantID) return;

    // Debounce the hover: Skip execution if the user is just fast-scrolling/moving the mouse past cards
    if (hoverTimeout) clearTimeout(hoverTimeout);
    
    hoverTimeout = setTimeout(function() {
      // Unpack Palo Alto's template cache if it hasn't loaded yet
      if (!deferredEl.hasAttribute('data-loaded') && typeof deferredEl.loadTemplate === 'function') {
        deferredEl.loadTemplate();
      }

      // Read from browser memory map or perform a single batched node collection loop
      let cachedData = cardCache.get(card);
      if (!cachedData) {
        cachedData = {
          mainImage: deferredEl.querySelector('[data-main-image]'),
          mediaImages: deferredEl.querySelectorAll('[data-variant-id], [data-variant-secondary-id]')
        };
        cardCache.set(card, cachedData);
      }

      // Batch all DOM style operations to execute during the next paint cycle (prevents layout shifts)
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          let matchFound = false;

          cachedData.mediaImages.forEach(function(imgBlock) {
            const varId = imgBlock.getAttribute('data-variant-id');
            const secVarId = imgBlock.getAttribute('data-variant-secondary-id');

            if (varId === targetVariantID || secVarId === targetVariantID) {
              imgBlock.style.cssText = 'display: block !important; opacity: 1 !important; visibility: visible !important; z-index: 3 !important;';
              matchFound = true;
            } else {
              imgBlock.style.cssText = 'display: none !important; opacity: 0 !important; z-index: 1 !important;';
            }
          });

          // Toggle visibility on the default out-of-the-box parent grid image asset
          if (cachedData.mainImage) {
            if (matchFound) {
              cachedData.mainImage.style.cssText = 'opacity: 0 !important; visibility: hidden !important;';
            } else {
              cachedData.mainImage.style.cssText = 'opacity: 1 !important; visibility: visible !important;';
            }
          }
        });
      });
    }, 35); // 35ms baseline threshold filters out intentional actions from accidentals
  }, true);

  // 2. Intercept mouse leaving the swatch wrapper component zone entirely
  document.addEventListener('mouseleave', function(event) {
    if (hoverTimeout) clearTimeout(hoverTimeout);
    if (!event.target || typeof event.target.closest !== 'function') return;

    const swatchWrapper = event.target.closest('[data-sibling-swatches-component]');
    if (!swatchWrapper) return;

    const card = swatchWrapper.closest('.product-grid-item') || swatchWrapper.closest('[data-product-grid-item]');
    if (!card) return;

    // Recall memory node coordinates instantly
    const cachedData = cardCache.get(card);
    if (!cachedData) return;

    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        cachedData.mediaImages.forEach(function(imgBlock) {
          imgBlock.style.removeProperty('display');
          imgBlock.style.removeProperty('opacity');
          imgBlock.style.removeProperty('visibility');
          imgBlock.style.removeProperty('z-index');
        });

        if (cachedData.mainImage) {
          cachedData.mainImage.style.removeProperty('opacity');
          cachedData.mainImage.style.removeProperty('visibility');
        }
      });
    });
  }, true);
})();